import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../../commonComponents/forms/FormInput';
import translate from '../../../../commonComponents/translate';
import SignedFileProp from '../../../../commonComponents/propTypes/signedFileProp';
import Loader from '../../../../services/loader';

function DocumentDropZone({
  t,
  documents,
  docType,
  handleDocuments,
  showUploadProgress,
  handleUploadLoading,
  handleRemove,
  ignoreDocumentTypeId,
}) {
  const loader = useRef(new Loader(`#document_${docType?._id}`));

  const document = !ignoreDocumentTypeId
    ? documents.filter(
        d => d?.documentTypeId?.toString() === docType?._id?.toString(),
      ) || []
    : documents || [];

  const handleUploadProgress = progress => {
    loader.current.showProgressLoader('');
    showUploadProgress(progress);
  };

  const handleComplete = () => {
    loader.current.hide();
    handleUploadLoading();
  };

  return (
    <div
      key={docType._id}
      className={document?.length > 0 ? 'inputFilled' : ''}
    >
      <h4 className="docType-title">{docType.name}:</h4>
      <FormInput
        id={`document_${docType._id}`}
        name={`document_${docType._id}`}
        value={JSON.stringify(document.map(d => d?.file))}
        onChange={value => handleDocuments(value, docType._id)}
        placeholder={t('journey.section.document.browseOrDrag')}
        containerClassName="docContainer"
        type="dropZone"
        inputProps={{
          maxFiles: 1,
          isImage: false,
          isCustomTemplate: true,
          customTemplateId: true,
          onRemoveFile: handleRemove ? handleRemove(docType) : null,
          onUploadProgress: progress => handleUploadProgress(progress),
          onCompleted: finished => handleComplete(finished),
          showLoader: true,
        }}
      />
    </div>
  );
}

DocumentDropZone.propTypes = {
  /** translation function */
  t: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.shape(SignedFileProp.propType)),
  docType: PropTypes.shape({
    name: PropTypes.string,
    _id: PropTypes.string,
  }).isRequired,
  handleDocuments: PropTypes.func.isRequired,
  showUploadProgress: PropTypes.func.isRequired,
  handleUploadLoading: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  ignoreDocumentTypeId: PropTypes.bool,
};

DocumentDropZone.defaultProps = {
  documents: [],
  ignoreDocumentTypeId: false,
};

export default translate(DocumentDropZone);
